import React, { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import "../css/MobileConsultation.css"; // Import the CSS file
import Vitals from "../components/Vitals";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CONSULTATION_APIS,
  consultationJSONAtom,
  medicineFormAtom,
} from "../../new_consultation/constants/_constant";
import { useAtom } from "jotai";
import AddConsultation from "./AddConsultation";
import FollowUp from "./FollowUp";
import { IoArrowBack } from "react-icons/io5";
import { MdNavigateNext, MdWaterDrop } from "react-icons/md";
import { isValidUrl } from "../../new_appointment/_helper/utils.js/utils";
import MedicineComponent from "./MedicineComponent";
import SuggestionList from "./SuggestionList";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { filterByTagType } from "../../new_consultation/views/CustomField";
import { toast } from "react-toastify";
import CuSpinner from "../../common_component/component/CuSpinner";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import CuMobileModal from "../../all-patient/components/CuMobileModal";
import MedicineDetails from "./MedicineDetails";
import Observation from "../components/Observation";
import Share from "../components/Share";
import { FaCheck, FaPrint } from "react-icons/fa6";
import { FaSave, FaShareAlt } from "react-icons/fa";
import { Spinner } from "@react-pdf-viewer/core";

const MobileConsultation = ({
  full_name,
  age,
  gender,
  vitals,
  setVitals,
  profile_image,
  customfields,
  setCustomfields,
  allergies,
  setAllergies,
  patientHistory,
  setPatientHistory,
  addictions,
  setAddictions,
  handleSaveConsultation,
  saveLoading,
  endLoading,
  advices,
  setAdvices,
  nextVisit,
  setNextVisit,
  setObservation,
  observation,
  medicineData,
  setMedicineData,
  billingServices,
  setBillingServices,
  setIsPrintPreview,
  sendNotification,
  isSendNotificationLoading,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [consultationJSON] = useAtom(consultationJSONAtom);
  const searchParams = new URLSearchParams(location.search);
  const step = searchParams.get("step");
  const [isSuggestion, setIsSuggestion] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [adviceInput, setAdviceInput] = useState("");
  const [openMedicineModal, setOpenMedicineModal] = useState(false);
  const [sharePrescription, setSharePrescription] = useState(false);
  const [medicine_id, setMedicineID] = useState(null);
  const [clinic] = useAtom(clinicAtom);

  const addQueryParam = (key, value) => {
    searchParams.set(key, value);
    navigate({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  let END_POINT = CONSULTATION_APIS[consultationJSON[step]?.offset];

  let query =
    consultationJSON[step]?.offset === "TAGS"
      ? `?name=${searchInput}&tag_type=${consultationJSON[step]?.tagId}`
      : `?name=${searchInput}`;

  if (consultationJSON[step]?.key === "adviceDirection") {
    END_POINT = ApiEndPoint.ADVICES;
    query = `?action=getAdvices&frontend=True&clinic_id=${clinic?.id}&name=${searchInput}&description=${searchInput}`;
  }

  if (consultationJSON[step]?.key === "medicineTable") {
    END_POINT = "master_data/name_medicine/";
    query = `?medicine_name=${searchInput}`;
  }

  if (consultationJSON[step]?.offset === "CLINIC_SERVICES") {
    END_POINT = CONSULTATION_APIS.CLINIC_SERVICES;
    query = `?action=getClinicServices&fronted=True&clinic_id=${clinic?.id}&name_of_service=${searchInput}`;
  }

  const { data: selectedData, isLoading } = useItemsFilter(
    END_POINT,
    query,
    step && searchInput?.length > 0 ? true : false
  );

  const handleAdviceSearch = (e) => {
    setAdvices({
      name: e.target.value.toUpperCase(),
      description: e.target.value.toUpperCase(),
    });
    setAdviceInput({
      name: e.target.value.toUpperCase(),
      description: e.target.value.toUpperCase(),
    });
    setSearchInput(e.target.value);
  };

  const handleSearch = (e) => {
    if (consultationJSON[step]?.label !== "Advice & Direction") {
      setSearchInput(e.target.value.toUpperCase());
    } else {
      handleAdviceSearch(e);
    }
  };

  const handleStepClick = (step) => {
    addQueryParam("step", step);
  };

  const getNextStep = () => {
    const nextStep = Number(step) + 1;
    if (nextStep <= consultationJSON?.length - 1) {
      return { label: consultationJSON[nextStep]?.label, step: nextStep };
    } else {
      return { label: "Done", step: -1 };
    }
  };

  const removeQueryParam = (param) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete(param);
    const newUrl = `${location.pathname}?${searchParams.toString()}`;
    navigate(newUrl, { replace: true });
  };

  const handleNextStepClick = () => {
    const nextStep = getNextStep()?.step;
    if (nextStep !== -1) {
      addQueryParam("step", nextStep);
    } else {
      removeQueryParam("step");
    }
  };

  const checkDuplicate = (val) => {
    const lowercaseLabel = consultationJSON[step]?.label
      ?.replace(/\s+/g, "")
      ?.toLowerCase();
    if (lowercaseLabel === "addictions") {
      const isAlreadyExist = addictions?.findIndex(
        (adc) => adc?.id === val?.id
      );
      if (isAlreadyExist === -1) {
        return val;
      } else {
        toast.error(`${val?.name} already exist`);
        return false;
      }
    } else if (lowercaseLabel === "allergy") {
      const isAlreadyExist = allergies?.findIndex((adc) => adc?.id === val?.id);
      if (isAlreadyExist === -1) {
        return val;
      } else {
        toast.error(`${val?.name} already exist`);
        return false;
      }
    } else if (lowercaseLabel === "patienthistory") {
      const isAlreadyExist = patientHistory?.findIndex(
        (adc) => adc?.id === val?.id
      );
      if (isAlreadyExist === -1) {
        return val;
      } else {
        toast.error(`${val?.name} already exist`);
        return false;
      }
    } else {
      const isAlreadyExist = customfields?.findIndex(
        (adc) =>
          adc?.id === val?.id &&
          adc?.tag_type?.includes(consultationJSON[step]?.tagId)
      );
      if (isAlreadyExist === -1) {
        return {
          ...val,
          tag_type: [consultationJSON[step]?.tagId],
        };
      } else {
        toast.error(`${val?.name} already exist`);
        return false;
      }
    }
  };

  console.log(advices);

  const handleAddCustomField = (selectedData = []) => {
    // console.log("SELECTED_DATA", selectedData);
    const lowercaseLabel = consultationJSON[step]?.label
      ?.replace(/\s+/g, "")
      ?.toLowerCase();
    if (lowercaseLabel === "addictions") {
      setAddictions(selectedData);
      // setCustomfields(selectedData);
    } else if (lowercaseLabel === "allergy") {
      setAllergies(selectedData);
      // setCustomfields(selectedData);
    } else if (lowercaseLabel === "patienthistory") {
      setPatientHistory(selectedData);
      // setCustomfields(selectedData);
    } else if (lowercaseLabel === "advice&direction") {
      setAdvices(selectedData);
      setAdviceInput(selectedData);
    } else if (lowercaseLabel === "billing") {
      setBillingServices(selectedData);
    } else {
      setCustomfields(selectedData);
    }
    handleCloseSuggestion();
  };

  const handleDeleteData = (id) => {
    const lowercaseLabel = consultationJSON[step]?.label
      ?.replace(/\s+/g, "")
      ?.toLowerCase();
    if (lowercaseLabel === "addictions") {
      setAddictions((prev) => prev?.filter((ele) => ele?.id !== id));
      return;
    }
    if (lowercaseLabel === "allergy") {
      setAllergies((prev) => prev?.filter((ele) => ele?.id !== id));
      return;
    }
    if (lowercaseLabel === "patienthistory") {
      setPatientHistory((prev) => prev?.filter((ele) => ele?.id !== id));
      return;
    }
    if (lowercaseLabel === "billing") {
      setBillingServices((prev) => prev?.filter((ele) => ele?.id !== id));
    }
    setCustomfields((prev) => prev?.filter((ele) => ele?.id !== id));
  };

  const handleCloseSuggestion = () => {
    setSearchInput("");
    setIsSuggestion(false);
  };

  const getDataToRender = (idx) => {
    const lowercaseLabel = consultationJSON[idx]?.label
      ?.replace(/\s+/g, "")
      ?.toLowerCase();
    if (lowercaseLabel === "addictions") {
      return addictions;
    }
    if (lowercaseLabel === "allergy") {
      return allergies;
    }
    if (lowercaseLabel === "patienthistory") {
      return patientHistory;
    }
    if (lowercaseLabel === "advice&direction") {
      return advices;
    }
    // if (lowercaseLabel === "billing") {
    //   return billingServices;
    // }
    return filterByTagType(customfields, consultationJSON[idx]?.tagId);
  };

  // console.log("Addaction", addictions);

  const checkIsDataFilled = (idx) => {
    const lowercaseLabel = consultationJSON[idx]?.label
      ?.replace(/\s+/g, "")
      ?.toLowerCase();
    const filledData = getDataToRender(idx);
    if (Array.isArray(filledData) && filledData?.length > 0) {
      return true;
    }
    if (lowercaseLabel === "advice&direction" && advices?.description) {
      return true;
    }
    if (lowercaseLabel === "nextvisit" && nextVisit?.length > 0) {
      return true;
    }
    if (lowercaseLabel === "billing" && billingServices.length > 0) {
      return true;
    }
    if (
      lowercaseLabel === "vitals" &&
      vitals?.some((ele) => Number(ele?.value1) > 0)
    ) {
      return true;
    }
    return false;
  };

  const medicineId = (id) => {
    setMedicineID(id);
    // console.log(id);
  };

  // console.log("medicineData", medicineData);

  return (
    <>
      {!step && (
        <div className="w-full px-4 border-t">
          <div className="w-full h-10 flex gap-4 items-center mt-4">
            <div className="w-[39px] h-[39px] rounded">
              {!profile_image || !isValidUrl(profile_image) ? (
                <div className="bg-[#C7EAC9] text-4xl font-bold rounded w-full h-full uppercase text-white flex justify-center items-center">
                  {full_name ? `${full_name[0]}` : "-"}
                </div>
              ) : (
                <img
                  className="w-full h-full rounded"
                  src={profile_image ? profile_image : ""}
                  alt="..."
                />
              )}
            </div>
            <div className="cu-mobile-consultation-patient-name">
              {full_name}
            </div>
          </div>
          <div className="mt-6">
            {consultationJSON?.map((item, idx) => (
              <div className="border-b pl-2 py-5">
                <div
                  key={item?.id}
                  // className="border-b"
                  onClick={() => handleStepClick(idx)}
                >
                  <div className="w-full flex justify-between items-center mb-2">
                    <div className="flex-1">{item?.label}</div>
                    <div>
                      {checkIsDataFilled(idx) ? (
                        <IoIosCheckmarkCircle size={25} color="#57D08B" />
                      ) : (
                        <FiPlus size={25} />
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-1 items-start text-[12px] text-[#404040]">
                  {consultationJSON[idx]?.key === "customField" &&
                    getDataToRender(idx)?.map((ele) => (
                      <span>{ele?.name}</span>
                    ))}

                  {consultationJSON[idx]?.label === "Billing" &&
                    billingServices.map((item) => (
                      <span>{item?.description}</span>
                    ))}
                  {consultationJSON[idx]?.key === "adviceDirection" && (
                    <span>{advices?.description}</span>
                  )}
                  {consultationJSON[idx]?.key === "nextVisit" && (
                    <span>{nextVisit}</span>
                  )}
                  {consultationJSON[idx]?.key === "observation" && (
                    <span>{observation}</span>
                  )}
                  {consultationJSON[idx]?.key === "medicineTable" &&
                    medicineData?.map((ele) => (
                      <span>{ele?.medicineName}</span>
                    ))}
                  {consultationJSON[idx]?.key === "vitals" && (
                    <div className="flex gap-4 flex-wrap">
                      {vitals?.map((vital) => {
                        const hasValue1 = Number(vital?.value1) > 0;
                        const hasValue2 = Number(vital?.value2) > 0;
                        const hasValue3 = Number(vital?.value3) > 0;
                        const separator = vital?.separator || "/"; // default to `/` if no separator provided

                        // Build the values string (e.g., "120/80")
                        const values = [
                          hasValue1 ? vital?.value1 : null,
                          hasValue2 ? vital?.value2 : null,
                          hasValue3 ? vital?.value3 : null,
                        ]
                          .filter((value) => value !== null)
                          .join(` ${separator} `); // Join with separator

                        // Only show the unit once at the end
                        const unit =
                          vital?.selected_unit3 ||
                          vital?.selected_unit2 ||
                          vital?.selected_unit;

                        return (
                          values && (
                            <div
                              className="flex gap-1 items-center w-[120px]"
                              key={vital?.id}
                            >
                              <MdWaterDrop color="black" />
                              <span className="text-[#404040] text-sx">
                                {values} {unit}
                              </span>
                            </div>
                          )
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="flex items-center gap-4 pt-4 justify-center">
            {/* Save Button */}
            <button
              className="h-[45px] bg-[#C7EAC9] rounded-lg text-[#575757] flex-1 flex border border-gray-300 justify-center items-center gap-2 hover:bg-[#b3dfb7] transition-colors duration-200 ease-in-out"
              onClick={() => handleSaveConsultation("draft", "save")}
            >
              {saveLoading ? (
                <CuSpinner />
              ) : (
                <>
                  <FaSave className="text-[#575757]" />
                  Save
                </>
              )}
            </button>

            {/* Share Button */}
            <button
              className="h-[45px] bg-[#C7EAC9] rounded-lg text-[#575757] flex-1 flex border border-gray-300 justify-center items-center gap-2 hover:bg-[#b3dfb7] transition-colors duration-200 ease-in-out"
              onClick={() => setSharePrescription(true)}
            >
              {saveLoading ? (
                <CuSpinner />
              ) : (
                <>
                  <FaShareAlt className="text-[#575757]" />
                  Share
                </>
              )}
            </button>

            {/* Print Button */}
            <button
              className="h-[45px] bg-[#C7EAC9] rounded-lg text-[#575757] flex-1 flex border border-gray-300 justify-center items-center gap-2 hover:bg-[#b3dfb7] transition-colors duration-200 ease-in-out"
              onClick={() => handleSaveConsultation("draft", "print")}
            >
              {saveLoading ? (
                <CuSpinner />
              ) : (
                <>
                  <FaPrint className="text-[#575757]" />
                  Print
                </>
              )}
            </button>

            {/* End Button */}
            <button
              className="h-[45px] bg-[#f94449] rounded-lg text-white flex-1 flex border border-transparent justify-center items-center gap-2 hover:bg-[#e63634] transition-colors duration-200 ease-in-out"
              onClick={() => handleSaveConsultation("published", "end")}
            >
              {endLoading ? (
                <CuSpinner />
              ) : (
                <>
                  <FaCheck className="text-white" />
                  End
                </>
              )}
            </button>
          </div>
        </div>
      )}

      {isSuggestion && (
        <SuggestionList
          setIsSuggestion={handleCloseSuggestion}
          handleSearch={handleSearch}
          searchInput={searchInput}
          selectedData={selectedData}
          handleAddData={handleAddCustomField}
          checkDuplicate={checkDuplicate}
          setOpenMedicineModal={setOpenMedicineModal}
          openMedicineModal={openMedicineModal}
          autoFocus={true}
          isLoading={isLoading}
          medicineID={medicineId}
          medicineData={medicineData} // medicineData passed down
          setMedicineData={setMedicineData} // Function to update medicineData
          currLabel={consultationJSON[step]?.key}
          setcustomField={setCustomfields}
          customData={customfields}
          addictions={addictions}
          setAddictions={setAddictions}
          allergies={allergies}
          setAllergies={setAllergies}
          patientHistory={patientHistory}
          setPatientHistory={setPatientHistory}
          billingServices={billingServices}
          setBillingServices={setBillingServices}
        />
      )}
      {!isSuggestion && (
        <>
          {step && (
            <div className="fixed w-full top-0 h-[82px] border-b bg-white px-4 flex justify-between items-center">
              <div className="flex items-center gap-4">
                <span>
                  <IoArrowBack size={25} onClick={() => navigate(-1)} />
                </span>
                <span className="text-xl text-[#000000]">
                  {consultationJSON[step]?.label}
                </span>
              </div>
              {/* <IoIosCheckmarkCircle
            size={25}
            color="#8B8B8B"
            // onClick={handleSubmit}
          /> */}
            </div>
          )}
          {step && consultationJSON[step]?.key === "customField" && (
            <AddConsultation
              setIsSuggestion={setIsSuggestion}
              customfields={getDataToRender(step)}
              handleDeleteData={handleDeleteData}
              addictions={addictions}
              allergies={allergies}
              patientHistory={patientHistory}
              billingServices={billingServices}
              setBillingServices={setBillingServices}
            />
          )}
          {step && consultationJSON[step]?.key === "adviceDirection" && (
            <AddConsultation
              handleSearch={handleSearch}
              searchInput={searchInput}
              selectedData={selectedData}
              handleAddData={handleAddCustomField}
              adviceInput={adviceInput}
            />
          )}
          {step && consultationJSON[step]?.key === "nextVisit" && (
            <FollowUp nextVisit={nextVisit} setNextVisit={setNextVisit} />
          )}
          {step && consultationJSON[step]?.key === "observation" && (
            <Observation
              setObservation={setObservation}
              observation={observation}
            />
          )}
          {step && consultationJSON[step]?.key === "vitals" && (
            // <div className="mt-[90px]">
            //    <ConsultationVitals vitals={vitals} setVitals={setVitals} />
            // </div>
            <Vitals vitals={vitals} setVitals={setVitals} />
          )}
          {step && consultationJSON[step]?.key === "medicineTable" && (
            <MedicineComponent
              setIsSuggestion={setIsSuggestion}
              medicineData={medicineData}
              setMedicineData={setMedicineData}
            />
          )}

          {step && (
            <div className="fixed bottom-3 w-full px-4 flex justify-between gap-4">
              <button
                className="h-[55px] rounded text-[#575757] flex-1 border"
                onClick={() => removeQueryParam("step")}
              >
                Preview
              </button>
              <button
                className="h-[55px] bg-[#C7EAC9] rounded text-[#575757] flex-1 flex border justify-center items-center"
                onClick={handleNextStepClick}
              >
                {getNextStep()?.label}
                <span>
                  <MdNavigateNext size={20} />
                </span>
              </button>
            </div>
          )}
        </>
      )}
      {openMedicineModal && (
        <CuMobileModal
          modalClassName="medicine-prescription"
          isOpen={openMedicineModal}
          closeModal={() => {
            setMedicineID("");
            setOpenMedicineModal(false);
          }}
        >
          <MedicineDetails
            closeModal={() => {
              setMedicineID("");
              setOpenMedicineModal(false);
            }}
            id={medicine_id}
            medicineData={medicineData}
            setMedicineData={setMedicineData}
            medicine_name={searchInput}
            setSearchInputG={setSearchInput}
            setIsSuggestion={setIsSuggestion}
          />
        </CuMobileModal>
      )}

      {sharePrescription && (
        <CuMobileModal
          modalClassName="cu-share-modal"
          isOpen={sharePrescription}
          closeModal={() => setSharePrescription(false)}
        >
          <Share
            onClose={() => {
              setSharePrescription(false);
            }}
            sendNotification={sendNotification}
            handleSaveConsultation={handleSaveConsultation}
            isSendNotificationLoading={isSendNotificationLoading}
          />
        </CuMobileModal>
      )}
    </>
  );
};

export default MobileConsultation;
